<script>
  import { createEventDispatcher } from "svelte"
  import AttributeContent from "./Components/attributeContent.svelte"
  const dispatch = createEventDispatcher()
  export let parsedJson

  let form
  let attributeValue = ""
  let disableAttributeBtn = true

  const handleSubmit = () => {
    const data = new FormData(form)
    let formData = [...data]

    for (let i = 0; i < formData.length; i++) {
      let tempValue = formData[i][1]
      if (tempValue != "None") attributeValue = attributeValue ? `${attributeValue}_${tempValue}` : [formData[i][1]]
    }
    dispatch("applyAndContinue", attributeValue)
  }
</script>

<div class="fixed inset-0 z-10 flex items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div class="relative m-6 w-[700px] transform rounded-md bg-white text-left shadow-xl transition-all dark:bg-bodyblack md:m-0">
    <form bind:this={form} on:submit|preventDefault>
      <div class="dark:Text-whtie flex w-full items-center justify-center rounded-md bg-white p-6 text-black dark:bg-bodyblack">
        <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Insert Attributes</h1>
      </div>

      <p class="mb-10 select-none px-10 text-center text-base font-medium text-gray-500">Here you can choose the attributes based on the document template you already chosen.</p>
      <div class="mx-auto w-8/12">
        <button class="flex w-full items-center justify-center rounded-md">
          <AttributeContent {parsedJson} bind:disableAttributeBtn />
        </button>
      </div>

      <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-6 dark:bg-bodyblack sm:flex md:gap-0">
        <button on:click type="button" class="group flex h-9 min-h-full min-w-[36px] items-center justify-center gap-2 rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto">
          <span class="text-gray-900 group-hover:text-white dark:text-white">
            <i class="fa-solid fa-circle-xmark" />
          </span>
          <span class="select-none">Back</span>
        </button>
        <button disabled={disableAttributeBtn} on:click={handleSubmit} type="submit" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto">
          <span>
            <i class="fa-solid fa-circle-check" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Insert Attribute</span>
        </button>
      </div>
    </form>
  </div>
</div>
